import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,
         ViewController,AlertController,ToastController } from 'ionic-angular';

//types
import {AddressItem} from '../model/types'

@IonicPage()
@Component({
  selector: 'page-manageaddress',
  templateUrl: 'manageaddress.html',
})
export class ManageaddressPage {
  
  curAddress:AddressItem;
  AddressId :number;
  ContactName  : string;
  Street1  : string;
  Street2  : string;
  LandMark   : string;
  LocationId : number;
  IsDefault  : number;
  Contact: string;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    private toastController:ToastController
  ){
    this.AddressId = navParams.data.AddressId || 0;
    this.ContactName = navParams.data.ContactName || "";
    this.Street1 = navParams.data.Street1 || "";
    this.Street2 = navParams.data.Street2 || "";
    this.LandMark = navParams.data.LandMark || "";
    this.LocationId = navParams.data.LocationId || 0;
    let val= navParams.data.IsDefault || false;
    this.IsDefault= (val==true ? 1:0);
    this.Contact = navParams.data.Contact || "";
   }
  ionViewDidLoad() {

  }
  DeleteAddress(){
    let alert = this.alertCtrl.create({
      title: 'Confirm delete',
      message: 'Do you want to delete address?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            this.viewCtrl.dismiss();
          }
        },
        {
          text: 'Confirm Delete',
          handler: () => {
            let data:AddressItem = { 
              AddressId: this.AddressId,
              ContactName:this.ContactName,
              Contact:this.Contact, 
              Street1:this.Street1,
              Street2:this.Street2,
              LocationId:this.LocationId,
              IsDefault:this.IsDefault==1 ? true : false,
              LandMark:this.LandMark,
              LocationName:'',
              Type:"delete"
             };
             this.viewCtrl.dismiss(data);
          }
        }
      ]
    });
    alert.present();
   }

  EditAddress(){
    if(this.ContactName.trim()==""){
      this.toastController.create({ message: "Contact name is required", duration: 2000, showCloseButton: true }).present();
    }
    else if(this.Street1.trim()==""){
      this.toastController.create({ message: "Street1 address is required", duration: 2000, showCloseButton: true }).present();
    }
    else if(this.Contact.trim()==""){
      this.toastController.create({ message: "Contact number is required", duration: 2000, showCloseButton: true }).present();
    }
    else if(this.AddressId<=0){
      this.toastController.create({ message: "Invalid address not able to update. Try again.", duration: 2000, showCloseButton: true }).present();
    }
    else
    {
      let data:AddressItem  = { 
                   AddressId: this.AddressId,
                   ContactName:this.ContactName,
                   Contact:this.Contact, 
                   Street1:this.Street1,
                   Street2:this.Street2,
                   LocationId:this.LocationId,
                   IsDefault:this.IsDefault==1 ? true : false,
                   LandMark:this.LandMark,
                   LocationName:'',
                   Type:"update"
                  };
      this.viewCtrl.dismiss(data);
      }
  }
  AddAddress(){
    if(this.Street1.trim()==""){
      this.toastController.create({ message: "Street1 address is required", duration: 2000, showCloseButton: true }).present();
    }
    else if(this.Contact.trim()==""){
      this.toastController.create({ message: "Contact number is required", duration: 2000, showCloseButton: true }).present();
    }
    else if(this.ContactName.trim()==""){
      this.toastController.create({ message: "Contact name is required", duration: 2000, showCloseButton: true }).present();
    }
    else
    {
      let data:AddressItem = { 
                   AddressId: this.AddressId,
                   ContactName:this.ContactName,
                   Contact:this.Contact, 
                   Street1:this.Street1,
                   Street2:this.Street2,
                   LocationId:this.LocationId,
                   IsDefault:this.IsDefault==1 ? true : false,
                   LandMark:this.LandMark,
                   LocationName:'',
                   Type:"add"
                  };
      this.viewCtrl.dismiss(data);
      }
  }
  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/manageaddress/manageaddress.ts